
import dayjs from "dayjs"

export const clearFilterData = {
  TukId: null,
  SpId: null,
  ChgDteSt: null,
  ChgDteEn: null,
}

export const initFilterData = {
  ...clearFilterData,
  ChgDteSt: dayjs().add(-30, "day").format("YYYY-MM-DD 00:00:00"),
  ChgDteEn: dayjs().format("YYYY-MM-DD 23:59:59"),
}

export const initOilChangeDialogData = {
  TukId: null,
  SpId: null,
  ChgDte: dayjs().format("YYYY-MM-DD"),
  Mileage: null,
  Qty: 0,
  UntPr: 0,
  TotalPr: 0,
  NxtMileage: null,
  MileageIntv: null,
  NxtDte: null,
  DteIntv: null,
  SupId: null,
  DocNo: "",
  DocDte: null,
  Dscp: "",
  Rmk: "",
}
